// This and its children will not be captured in PostHog session replay recordings.
export function NoCapture({ children }: React.PropsWithChildren) {
  return <span className="ph-no-capture">{children}</span>;
}
